var Utils = require('@amzn/aws-workdocs-web-client-common').Utils;
var BrowserService = require('@amzn/aws-workdocs-web-client-common').BrowserService;

(function() {
    'use strict';

    angular.module('GorillaBoy.Admin')
    .controller('AdministrationController', [
        '$scope',
        '$rootScope',
        '$log',
        '$routeParams',
        '$filter',
        '$q',
        '$location',
        '$timeout',
        '$translate',
        '$uibModal',
        'ClientMetricsService',
        'MetricEvents',
        'OrganizationService',
        'InviteService',
        'UserService',
        'MessageManager',
        'FeatureManagerService',
        'FileManagerFactory',
        'Features',
        'AuthService',
        'SortService',
        'focus',
        'SourceConstant',
        'AppConstants',
        'userInfo',
        'UserStatus',
        'StorageType',
        'CompanionService',
        'CompanionClientService',
        'AuditEmailService',
        AdministrationController
    ]);

    function AdministrationController($scope, $rootScope, $log, $routeParams, 
        $filter, $q, $location, $timeout, $translate, $uibModal, 
        ClientMetricsService, MetricEvents, OrganizationService, InviteService,
        UserService, MessageManager, FeatureManagerService, FileManagerFactory, 
        Features, AuthService, SortService, focus, SourceConstant, AppConstants, 
        userInfo, UserStatus, StorageType, CompanionService, 
        CompanionClientService, AuditEmailService) {

            // Group Types
            // WORKSPACES_USER - Using Workspaces.
            // ZOCALO_USER - Using Zocalo.
            // A User can have both the group types.
        var GROUP_TYPE_WS_USER = 'WORKSPACES_USER',
            GROUP_TYPE_GB_USER = 'ZOCALO_USER',

            USER_TYPE_USER = 'USER',
            USER_TYPE_ADMIN = 'ADMIN',
            USER_TYPE_POWERUSER = 'POWERUSER',
            USER_TYPE_MINIMALUSER = 'MINIMALUSER',
            USER_TYPE_WORKSPACESUSER = 'WORKSPACESUSER',

            EXPORT_USERS_MIN_COMPANION_VERSION = '1.0.57.0',

            // UI Texts for user role.
            WS_USER = $translate.instant('ADMIN.CONTENT_PARTIAL.WS_USER'),
            GB_USER = $translate.instant('ADMIN.CONTENT_PARTIAL.GB_USER'),
            ADMIN_USER = $translate.instant('ADMIN.CONTENT_PARTIAL.ADMIN_USER'),
            POWER_USER = $translate.instant('ADMIN.CONTENT_PARTIAL.POWER_USER'),
            MINIMAL_USER = $translate.instant('ADMIN.CONTENT_PARTIAL.MINIMAL_USER'),

            // AppConstant bindings
            viewTypes = AppConstants.ViewTypes,
            sortOrder = SortService.CONSTANTS.ORDER,
            layoutViewTypes = AppConstants.LayoutViewTypes,
            BYTES_TO_GIGABYTES = AppConstants.BYTES_TO_GIGABYTES,
            skuTypes = AppConstants.SkuType,
            SECONDS_IN_DAY = AppConstants.SECONDS_IN_DAY,

            // all modal instances
            meetingsConfigModal = null,
            office365ConfigModal = null,
            onlineEditingConfigModal = null,
            reinvitePendingUsersModal = null,
            reinviteUserModal = null,
            individualLimitModal = null,
            sharingModal = null,
            adminInviteModal = null,
            inviteModal = null,
            deleteUserModal = null,
            editUserModal = null,
            recoveryRetentionModal = null,
            contentSearchModal = null,
            auditEmailModal = null,
            confirmAuditEmailModal = null,
            removeAuditEmailModal = null,
            verifyAuditEmailModal = null,
            params = $location.search();

        activate();

        /**
         * Main function that gets invoked when this controller is activated.
         */
        function activate() {
            FileManagerFactory.setUserContext(userInfo);
            // Main
            $rootScope.preFetchSharedWithMeDebounced();
            $scope.userInfo = userInfo;
            $scope.SkuTypes = skuTypes;
            $scope.ViewTypes = viewTypes;
            $scope.UserStatus = UserStatus;
            $scope.StorageType = StorageType;
            $scope.SortOrder = sortOrder;
            $scope.BYTES_TO_GIGABYTES = BYTES_TO_GIGABYTES;
            $scope.isPowerUserEnabled = FeatureManagerService.isFeatureEnabled(Features.UI.EDIT_POWERUSER);
            $scope.isLinkSharingEnabled = FeatureManagerService.isFeatureEnabled(Features.UI.ENABLE_LINK);
            $scope.userRoles = [MINIMAL_USER, WS_USER, GB_USER, POWER_USER, ADMIN_USER];
            $scope.isInvitePowerUserEnabled = FeatureManagerService.isFeatureEnabled(Features.UI.INVITE_POWERUSER);
            $scope.isExternalSharingEnabled = FeatureManagerService.isFeatureEnabled(Features.UI.EXTERNAL_SHARE);
            $scope.isMinimalUserEnabled = FeatureManagerService.isFeatureEnabled(Features.UI.MINIMAL_USER);
            $scope.isBasicUser = (userInfo.SkuType === $scope.SkuTypes.BASIC) ? true : false;
            $scope.isResourceRecoveryEnabled = FeatureManagerService.isFeatureEnabled(Features.UI.RECOVERY_FOLDER);
            $scope.isSearchV2Enabled = FeatureManagerService.isFeatureEnabled(Features.UI.SEARCH_V2);
            $scope.isMeetingsEnabled = FeatureManagerService.isFeatureEnabled(Features.UI.MEETINGS);
            $scope.isAuditEmailEnabled = FeatureManagerService.isFeatureEnabled(Features.UI.AUDIT_EMAIL);
            $scope.userTypes = {};
            $scope.userTypes[USER_TYPE_MINIMALUSER] = MINIMAL_USER;
            $scope.userTypes[USER_TYPE_WORKSPACESUSER] = WS_USER;
            $scope.userTypes[USER_TYPE_USER] = GB_USER;
            $scope.userTypes[USER_TYPE_POWERUSER] = POWER_USER;
            $scope.userTypes[USER_TYPE_ADMIN] = ADMIN_USER;
            $scope.disableContentSearchPattern = /^DISABLE CONTENT SEARCH$/;


            // SECTION: Layout code
            $scope.layout = {
                partialContent: './admin/content_partial.html',
                partialModals: './admin/modals.html',
                partialTitleBar: './admin/title_bar.html',
                view: layoutViewTypes.VIEW_ADMIN_LAYOUT,
                //Master copy of whether left sidebar should be shown/hidden.
                showLeftSidebar: $rootScope.showLeftSidebar,
                hasRightSidebar: false,
                showRightSidebar: false,
                showUploadPane: false
            };

            $scope.adminForm = {
                tenantIdForO365: '',
                enableO365 : false,
                o365SettingUpdated : false,
                meetingsSettingUpdated : false,
            };

            $scope.onlineEditingForm = {
                enableOnlineEditing : false,
                enableOnlineEditingTemporary : false,
                onlineEditingSettingUpdated : false,
            };
            // SECTION: Initialization / state variables
            $scope.adminState = {

                showOnlineEditingSection : false,
                savingOfficeConfig : false,
                savingMeetingsConfig : false,
                savingOnlineEditingConfig : false,

                //These track the server side values
                tenantIdForO365: '',
                enableO365 : false,

                enableOnlineEditing : false,

                viewDashboard: true,
                sharingScope: '',
                inviteScope: '',
                externalShareScope: '',
                externalShareAllowStatus: false,
                isNewADUserTypeManaged: false,
                isNewExternalUserTypeManaged: false,
                isSelfActivationEnabled: true,
                sharingDomainList: null,
                inviteDomainList: null,
                organizationalStorageUsed: null,
                individualDefaultLimit: null,
                individualUnlimited: null,
                temporaryEmailList: [],
                temporaryEmail: '',
                temporaryEmailError: '',
                temporaryInvalidEmailList: [],
                temporaryMessage: '',
                temporarySubject: '',
                temporaryDomainList: [],
                temporaryDomainError: '',
                temporaryInvalidDomainList: [],
                temporaryScope: '',
                temporaryDomain: '',
                temporaryInviteScope: '',
                temporary: {},
                temporaryExternalShareScope: '',
                temporaryExternalShareAllowStatus: false,
                temporaryIsNewADUserTypeManaged: false,
                temporaryIsNewExternalUserTypeManaged: false,
                temporaryIsSelfActivationEnabled: true,
                organizationalNumWorkDrives: null,

                contentSearchDisableText: ''
            };

            $scope.COUNT_PER_PAGE = 50;
            $scope.sortOptions = {
                USER_NAME: 'USER_NAME',
                FULL_NAME: 'FULL_NAME',
                STORAGE_LIMIT: 'STORAGE_LIMIT',
                USER_STATUS: 'USER_STATUS',
                STORAGE_USED: 'STORAGE_USED'
            };

            $scope.sortOptionType = params.sortBy || $scope.sortOptions.FULL_NAME;
            $scope.sortOptionOrder = params.order || sortOrder.ASCENDING;
            $scope.query = {};
            $scope.query.searchQuery = params.searchQuery || undefined;
            $scope.emptyMessage = $translate.instant('MESSAGES.EMPTY_MESSAGE_USER_ADMIN', {
                name: $scope.escapeHTML($scope.query.searchQuery)
            });
            $scope.ORGANIZATION_TYPE_STANDALONE = 'STANDALONE';
            $scope.ORGANIZATION_TYPE_CONNECTED = 'CONNECTED';
            $scope.ORGANIZATION_TYPE_FEDERATED = 'FEDERATED_IDENTITY';
            $scope.ORGANIZATION_SCOPE_ANYONE = 'ANYONE';
            $scope.ORGANIZATION_SCOPE_DOMAINS = 'DOMAINS';
            $scope.ORGANIZATION_SCOPE_ORGANIZATION = 'ORGANIZATION';
            $scope.ORGANIZATION_SCOPE_POWERUSER = 'POWERUSER';
            $scope.ORGANIZATION_SCOPE_ADMIN = 'ADMIN';
            $scope.ORGANIZATION_SCOPE_MANAGED = 'MANAGED';
            $scope.SHARE_SETTINGS_SCOPE_NONE = 'NONE';

            $scope.ALLOWSTATUS_ENABLED = 'ENABLED';
            $scope.ALLOWSTATUS_DISABLED = 'DISABLED';

            $scope.MAX_RETENTION_DAYS = 365;
            $scope.MIN_RETENTION_DAYS = 0;
            $scope.NEW_USER_TYPE_MANAGED = 'MANAGED';
            $scope.NEW_USER_TYPE_MINIMAL = 'MINIMAL';

            $scope.pagination = {
                previousMarkers: [],
                marker : null,
                first_text: $translate.instant('ADMIN.ACTIVITY.FIRST'),
                last_text: $translate.instant('ADMIN.ACTIVITY.LAST'),
                previous_text: $translate.instant('ADMIN.ACTIVITY.PREVIOUS'),
                next_text: $translate.instant('ADMIN.ACTIVITY.NEXT')
            };

            $scope.languageSettings = {
                locale: null,
                localeValues: AppConstants.LocaleValues
            };

            $scope.auditEmailState = {
                verifiedEmail: '',
                unverifiedEmail: '',
                showSpinner: false,
                newAuditEmail: '',
                toRemoveAuditEmail: '',
            };

            $scope.getFullname = function(user) {
                return $rootScope.getFullName(user);
            };

            $scope.saveOffice365Config = function() {
                if($scope.adminForm.o365SettingUpdated){
                    var p1 = OrganizationService.toggleOrgFeature(AppConstants.ORG_FEATURES.O365, $scope.adminForm.enableO365);

                    $scope.adminState.savingOfficeConfig = true;

                    p1.then(function() {
                        MessageManager.addSuccessMessage($translate.instant('O365.SUCCESS.SAVED_CONFIG'));
                        //the value in the rootscope is used across the app for enable/disabling the option, so update the value
                        $rootScope.office365EditingEnabled = $scope.adminState.enableO365 = $scope.adminForm.enableO365;
                        emitO365ConfigChangeMetric();
                    }, function() {
                        MessageManager.addErrorMessage($translate.instant('O365.ERRORS.ERROR_SAVING_CONFIG'));
                    }).finally(function() {
                        office365ConfigModal.close();
                        office365ConfigModal = null;
                        $scope.adminState.savingOfficeConfig = false;
                    });
                }
            };

            $scope.saveMeetingsConfig = function() {
                if($scope.adminForm.meetingsSettingUpdated){
                    var p1 = OrganizationService.toggleOrgFeature(AppConstants.ORG_FEATURES.MEETINGS, $scope.adminForm.enableMeetings);

                    $scope.adminState.savingMeetingsConfig = true;

                    p1.then(function() {
                        MessageManager.addSuccessMessage($translate.instant('MEETINGS.SUCCESS.SAVED_CONFIG'));
                        //the value in the rootscope is used across the app for enable/disabling the option, so update the value
                        $rootScope.isMeetingsEnabled = $scope.adminState.enableMeetings = $scope.adminForm.enableMeetings;
                        emitO365ConfigChangeMetric();
                    }, function() {
                        MessageManager.addErrorMessage($translate.instant('MEETINGS.ERRORS.ERROR_SAVING_CONFIG'));
                    }).finally(function() {
                        meetingsConfigModal.close();
                        meetingsConfigModal = null;
                        $scope.adminState.savingMeetingsConfig = false;
                    });
                }
            };

            $scope.saveOnlineEditingConfig = function() {
                if($scope.onlineEditingForm.onlineEditingSettingUpdated){
                    var p1 = OrganizationService.toggleOrgFeature(AppConstants.ORG_FEATURES.ONLINE_EDITING, $scope.onlineEditingForm.enableOnlineEditingTemporary);

                    $scope.adminState.savingOnlineEditingConfig = true;

                    p1.then(function() {
                        MessageManager.addSuccessMessage($translate.instant('ONLINEEDITING.SUCCESS.SAVED_CONFIG'));
                        $scope.adminState.enableOnlineEditing = $scope.onlineEditingForm.enableOnlineEditing = $scope.onlineEditingForm.enableOnlineEditingTemporary;
                    }, function() {
                        MessageManager.addErrorMessage($translate.instant('ONLINEEDITING.ERRORS.ERROR_SAVING_CONFIG'));
                    }).finally(function() {
                        onlineEditingConfigModal.close();
                        onlineEditingConfigModal = null;
                        $scope.adminState.savingOnlineEditingConfig = false;
                    });
                }
            };

            $scope.officeSettingChanged = function() {
                $scope.adminForm.o365SettingUpdated = !$scope.adminForm.o365SettingUpdated;
            };

            $scope.meetingSettingChanged = function() {
                $scope.adminForm.meetingsSettingUpdated = !$scope.adminForm.meetingsSettingUpdated;
            };

            $scope.showOffice365ConfigModal = function() {
                $scope.adminForm.o365SettingUpdated = false;
                $scope.adminForm.enableO365 = $scope.adminState.enableO365 = $rootScope.office365EditingEnabled;
                office365ConfigModal = $uibModal.open({
                    templateUrl: 'office365ConfigModal.html',
                    size: 'md',
                    scope: $scope
                });
            };

             $scope.showMeetingConfigModal = function() {
                $scope.adminForm.meetingsSettingUpdated = false;
                meetingsConfigModal = $uibModal.open({
                    templateUrl: 'meetingsConfigModal.html',
                    size: 'md',
                    scope: $scope
                });
            };

            $scope.onlineEditingSettingChanged = function() {
                $scope.onlineEditingForm.onlineEditingSettingUpdated = !$scope.onlineEditingForm.onlineEditingSettingUpdated;
            };

            $scope.showOnlineEditingConfigModal = function() {
                $scope.onlineEditingForm.onlineEditingSettingUpdated = false;
                $scope.onlineEditingForm.enableOnlineEditingTemporary = $scope.onlineEditingForm.enableOnlineEditing;
                onlineEditingConfigModal = $uibModal.open({
                    templateUrl: 'onlineEditingConfigModal.html',
                    size: 'md',
                    scope: $scope
                });
            };

            // SECTION: Modals
            $scope.showStorageModal = function() {
                $scope.adminState.temporary.individualDefaultLimit = $scope.adminState.individualDefaultLimit;
                $scope.adminState.temporary.individualUnlimited = $scope.adminState.individualUnlimited;

                individualLimitModal = $uibModal.open({
                    templateUrl: 'individualLimitModal.html',
                    size: 'md',
                    scope: $scope
                });
            };

            $scope.showShareFilesModal = function() {
                $scope.adminState.temporaryScope = $scope.adminState.orgWideSharingScope === 'NONE' ? $scope.adminState.orgWideSharingScope : $scope.adminState.sharingScope;
                $scope.adminState.temporaryDomain = '';
                $scope.adminState.temporaryDomainList = angular.copy($scope.adminState.sharingDomainList) || [];
                $scope.adminState.temporaryDomainError = '';
                $scope.adminState.temporaryInvalidDomainList = [];

                sharingModal = $uibModal.open({
                    templateUrl: 'sharingModal.html',
                    size: 'lg',
                    scope: $scope
                });
                AppConstants.ORG_WIDE_SHARING_SCOPE = $scope.adminState.temporaryScope;
            };

            $scope.showIpWhitelistingModal = function() {
                var IP_WHITELISTING_MODAL_SHOWN = {name: 'IP_Whitelisting_Modal_Shown'};
                ClientMetricsService.recordCounterEvent(IP_WHITELISTING_MODAL_SHOWN, 1);
                var ipWhitelistingModal = $uibModal.open({
                    templateUrl: './shared/ipWhitelistingModal.html',
                    controller: 'IpWhitelistingCtrl',
                    size: 'md'
                });

                $scope.$on("$destroy", function() {
                    if (ipWhitelistingModal) {
                        ipWhitelistingModal.close();
                    }
                });

                ipWhitelistingModal.result.finally(function() {
                    if (ipWhitelistingModal) {
                        ipWhitelistingModal.close();
                    }
                });
            };

            $scope.showSecurityPolicyModal = function() {

                $scope.adminState.temporaryScope = $scope.adminState.orgWideSharingScope === 'NONE' ? $scope.adminState.orgWideSharingScope : $scope.adminState.sharingScope;
                $scope.adminState.temporaryInviteScope = $scope.adminState.inviteScope;
                $scope.adminState.temporaryExternalShareAllowStatus = $scope.adminState.externalShareAllowStatus;
                $scope.adminState.temporaryExternalShareScope = $scope.adminState.externalShareScope;
                $scope.adminState.temporaryIsNewADUserTypeManaged = $scope.adminState.isNewADUserTypeManaged;
                $scope.adminState.temporaryIsSelfActivationEnabled = $scope.adminState.isSelfActivationEnabled;
                $scope.adminState.temporaryIsNewExternalUserTypeManaged = $scope.adminState.isNewExternalUserTypeManaged;
                $scope.adminState.temporaryDomain = '';
                $scope.adminState.temporaryDomainList = angular.copy($scope.adminState.inviteDomainList) || [];
                $scope.adminState.temporaryDomainError = '';
                $scope.adminState.temporaryInvalidDomainList = [];
                sharingModal = $uibModal.open({
                    templateUrl: 'securityPolicyModal.html',
                    size: 'lg',
                    scope: $scope
                });
            };

            $scope.showAdminInviteModal = function() {
                $scope.adminState.temporaryScope = $scope.adminState.inviteScope;
                $scope.adminState.temporaryDomain = '';
                $scope.adminState.temporaryDomainList = angular.copy($scope.adminState.inviteDomainList) || [];
                $scope.adminState.temporaryDomainError = '';
                $scope.adminState.temporaryInvalidDomainList = [];

                adminInviteModal = $uibModal.open({
                    templateUrl: 'adminInviteModal.html',
                    size: 'lg',
                    scope: $scope
                });
            };

            $scope.showInviteUsersModal = function() {
                $scope.adminState.temporaryEmailList = [];
                $scope.adminState.temporaryEmail = '';
                $scope.adminState.temporarySubject = '';
                $scope.adminState.temporaryMessage = '';
                $scope.adminState.temporaryEmailError = '';
                $scope.adminState.temporaryInvalidEmailList = [];

                inviteModal = $uibModal.open({
                    templateUrl: 'inviteModal.html',
                    size: 'lg',
                    scope: $scope
                });
            };

            $scope.sendUserInvites = function() {
                var emails;

                if (!this.adminState.temporaryEmailList || this.adminState.temporaryEmailList.length === 0) {
                    MessageManager.addErrorMessage($translate.instant('MESSAGES.INVITE_FAIL_EMPTY_EMAIL'));
                    return;
                } else {
                    emails = this.adminState.temporaryEmailList;
                    emails = $filter('filter')(emails, $scope.filterZerolengthStrings);

                    inviteModal.close();

                    InviteService.inviteUsers(emails, this.adminState.temporarySubject, this.adminState.temporaryMessage)
                    .success(processInviteResponse)
                    .error(processInviteFailure);
                }
            };

            $scope.showRecoveryRetentionModal = function() {
                $scope.adminState.temporaryRecoveryRetentionDays = $scope.adminState.recoveryRetentionDays;

                recoveryRetentionModal = $uibModal.open({
                   templateUrl: 'recoveryRetentionModal.html',
                   size: 'md',
                   scope: $scope
                });
            };

            $scope.showContentSearchModal = function() {
                // You can disable content search only if it is enable.
                // You cannot go from disable to enable.
                if (!$rootScope.isContentSearchEnabled) {
                    return;
                }

                contentSearchModal = $uibModal.open({
                   templateUrl: 'contentSearchModal.html',
                   size: 'md',
                   scope: $scope
                });
            };

            $scope.showDeleteUserModal = function(user) {
                if (user.Status === UserStatus.USER_STATUS_PENDING) {
                    $scope.target_user = user;

                    deleteUserModal = $uibModal.open({
                        templateUrl: 'deleteUserModal.html',
                        scope: $scope
                    });
                }
            };

            $scope.showReinviteUserModalFromInvite = function(pendingInvites) {
                if (inviteModal) {
                    inviteModal.dismiss();
                }
                $scope.pendingInvites = pendingInvites;

                reinvitePendingUsersModal = $uibModal.open({
                    templateUrl: 'reinvitePendingUsersModal.html',
                    scope: $scope
                });
            };

            $scope.showReinviteUserModal = function(user) {
                if (user.Status === UserStatus.USER_STATUS_PENDING) {
                    $scope.target_user = user;

                    reinviteUserModal = $uibModal.open({
                        templateUrl: 'reinviteUserModal.html',
                        scope: $scope
                    });
                }
            };

            // Downgrade to Workspace user

            $scope.downgradeToWSUser = function () {
                // Change the storage type to 'QUOTA' for Workspaces user
                $scope.edited_user.EditedStorage.StorageUnlimited = StorageType.STORAGE_QUOTA_TYPE;
                // Remove the 'GB_USER' group type for the user
                if ($scope.edited_user.groupTypes === null) {
                    return;
                }
                for (var i = $scope.edited_user.groupTypes.length - 1; i >= 0; i--) {
                    if ($scope.edited_user.groupTypes[i] === GROUP_TYPE_GB_USER) {
                        $scope.edited_user.groupTypes.splice(i, 1);
                        // Change the UI text
                        $scope.edited_user.readableUserType = WS_USER;
                        break;
                    }
                }
                // Set the boolean flags if the upgrade/downgrade is required
                $scope.edited_user.upgradeRequired = false;
                $scope.edited_user.downgradeRequired = true;
            };

            // Upgrade to Zocalo User

            $scope.upgradeToZocaloUser = function () {
                // Check and add 'GB_USER' group type to the user
                for (var i = 0; i < $scope.edited_user.groupTypes.length - 1; i++) {
                    if ($scope.edited_user.groupTypes[i] === GROUP_TYPE_GB_USER) {
                        return;
                    }
                }
                $scope.edited_user.groupTypes.push(GROUP_TYPE_GB_USER);
                // Change the UI text
                $scope.edited_user.readableUserType = GB_USER;
                // Set the boolean flags if the upgrade/downgrade is required
                $scope.edited_user.upgradeRequired = true;
                $scope.edited_user.downgradeRequired = false;
            };

            // Get the user role in 'Edit User' modal
            $scope.getUserTypeInModal = function(user) {
                var isZocaloUser = false;
                var isWSUser = false;
                if (!!user.GroupTypes) {
                    for (var i = 0, size = user.GroupTypes.length; i < size; i++) {
                        var group = user.GroupTypes[i];
                        if (group === GROUP_TYPE_GB_USER) {
                            isZocaloUser = true;
                        } else if (group === GROUP_TYPE_WS_USER) {
                            isWSUser = true;
                        }
                    }
                }
                if (isZocaloUser) {
                    // If the user is a zocalo user
                    return GB_USER;
                } else if (isWSUser) {
                    // If the user is a workspaces user and not a zocalo user
                    return WS_USER;
                } else {
                    // Default case (This is not possible !!!)
                    return GB_USER;
                }
            };

            $scope.userRoleFilter = function (userRole) {
                if(userRole === MINIMAL_USER) {
                    // If a user is currently a minimal user, show that option regardless of whether or not the feature is on
                    if($scope.original_user.MinimalUser) {
                        return true;
                    }
                    // If a user is currently a WS user, he cannot be a minimal user
                    if($scope.isWSUserHelper($scope.original_user.GroupTypes)) {
                        return false;
                    }
                    if(!$scope.isMinimalUserEnabled) {
                        return false;
                    }
                }
                if(userRole === WS_USER) {
                    return $scope.isWSUserHelper($scope.original_user.GroupTypes);
                }
                if(userRole === GB_USER) {
                    return !$scope.isWSUserHelper($scope.original_user.GroupTypes);
                }
                if(!$scope.isPowerUserEnabled && userRole === POWER_USER) {
                    return false;
                }
                return true;
            };

            $scope.showEditUserModal = function(user) {
                $scope.selectedUserRole = $scope.getRole(user);
                $scope.edited_user = angular.copy(user);
                $scope.original_user = user;
                $scope.edited_user.inputOwnershipTransfer = false;
                $scope.edited_user.transfereeUsername = '';
                $scope.edited_user.groupTypes = user.GroupTypes;
                $scope.edited_user.readableUserType = $scope.getUserTypeInModal(user);
                $scope.messageEmails = [];
                $scope.edited_user.EditedStorage = {
                    StorageUnlimited: $scope.edited_user.Storage.StorageRule.StorageType
                };

                if ($scope.edited_user.EditedStorage.StorageUnlimited === 'UNLIMITED') {
                    $scope.edited_user.EditedStorage.StorageLimit = $scope.adminState.individualDefaultLimit;
                } else {
                    $scope.edited_user.EditedStorage.StorageLimit = $scope.edited_user.Storage.StorageRule.StorageAllocatedInBytes / BYTES_TO_GIGABYTES;
                }

                $scope.edited_user.upgradeRequired = false;
                $scope.edited_user.downgradeRequired = false;
                // This is needed in case MINIMAL_USER was selected as a default for the dropdown and not because the user is actually currently a minimal user
                if($scope.selectedUserRole == MINIMAL_USER) {
                    $scope.edited_user.MinimalUser = true;
                }
                $scope.edited_user.managedUser = !$scope.edited_user.Administrator && !$scope.edited_user.Poweruser && !$scope.edited_user.MinimalUser;

                editUserModal = $uibModal.open({
                    templateUrl: 'editUserModal.html',
                    size: 'lg',
                    scope: $scope
                });
            };

            $scope.focusDomainInput = function() {
                $timeout(function() {
                    focus($scope.ORGANIZATION_SCOPE_DOMAINS);
                });
            };

            $scope.removeTemporaryDomain = function(index) {
                // TODO (simmkyu): Use ng-animate in the future version of AngularJS.
                var domainElement = $('.domain-list').children('li').eq(index);
                domainElement.slideUp(400, function() {
                    $scope.adminState.temporaryDomainList.splice(index, 1);
                });
            };

            var hasTemporaryInvalidDomainList = function() {
                return $scope.adminState.temporaryInvalidDomainList && $scope.adminState.temporaryInvalidDomainList.length > 0;
            };

            var checkAddDomainErrorMessage = function(userSubmit) {
                if (hasTemporaryInvalidDomainList()) {
                    $scope.adminState.temporaryDomainError = $translate.instant('MESSAGES.SECURITY_ORGANIZATION_MODAL_INVALID_DEFAULT');
                } else {
                    $scope.adminState.temporaryDomainError = '';
                }
            };

            $scope.removeTemporaryInvalidDomain = function(index) {
                $scope.adminState.temporaryInvalidDomainList.splice(index, 1);
                checkAddDomainErrorMessage();
            };

            $scope.addDomainCheck = function(event) {

                if (event.keyCode === AppConstants.KeyCodes.ENTER) {
                    $scope.addDomain(event);
                } else {
                  checkAddDomainErrorMessage();
                }

            };

            $scope.addDomain = function(event) {
                // This regex splits along semi-colons, spaces, and commas
                var domains = $scope.adminState.temporaryDomain.replace(/[;\s]/g, ',').split(','),
                    valid_domains,
                    invalid_domains;
                domains = $filter('filter')(domains, $scope.filterZerolengthStrings);
                invalid_domains = $filter('filter')(domains, $scope.filterInvalidDomain);
                valid_domains = $filter('filter')(domains, $scope.filterValidDomain);
                $scope.adminState.temporaryDomain = '';
                if (!domains || invalid_domains.length) {
                    $scope.adminState.temporaryInvalidDomainList = invalid_domains;
                    $scope.adminState.temporaryDomainList = $scope.adminState.temporaryDomainList.concat(valid_domains);
                    checkAddDomainErrorMessage();
                } else {
                    $scope.adminState.temporaryDomainList = $scope.adminState.temporaryDomainList.concat(valid_domains);
                    $scope.adminState.temporaryDomainList = $filter('unique')($scope.adminState.temporaryDomainList);
                    checkAddDomainErrorMessage();
                }
            };

            var checkAddEmailErrorMessage = function() {
                if ($scope.adminState.temporaryInvalidEmailList && $scope.adminState.temporaryInvalidEmailList.length > 0) {
                    $scope.adminState.temporaryEmailError = $translate.instant('MESSAGES.SECURITY_UPDATE_MODAL_INVALID_DEFAULT');
                } else {
                    $scope.adminState.temporaryEmailError = '';
                }
            };

            $scope.addEmailCheck = function(event) {

                if (event.keyCode === AppConstants.KeyCodes.ENTER) {
                    $scope.addEmail(event);
                } else {
                  checkAddEmailErrorMessage();
                }

            };

            $scope.addEmail = function() {
                // This regex splits along semi-colons, spaces, and commas
                var emails = $scope.adminState.temporaryEmail.replace(/[;\s]/g, ',').split(','),
                    valid_emails,
                    invalid_emails;
                emails = $filter('filter')(emails, $scope.filterZerolengthStrings);
                invalid_emails = $filter('filter')(emails, $scope.filterInvalidEmail);
                valid_emails = $filter('filter')(emails, $scope.filterValidEmail);

                $scope.adminState.temporaryEmail = '';
                if (!emails || invalid_emails.length) {
                    $scope.adminState.temporaryInvalidEmailList = invalid_emails;
                    $scope.adminState.temporaryEmailList = $scope.adminState.temporaryEmailList.concat(valid_emails);
                    checkAddEmailErrorMessage();
                } else {
                    $scope.adminState.temporaryEmailList = $scope.adminState.temporaryEmailList.concat(emails);
                    $scope.adminState.temporaryEmailList = $filter('unique')($scope.adminState.temporaryEmailList);
                    checkAddEmailErrorMessage();
                }
            };

            $scope.removeTemporaryEmail = function(index) {
                // TODO (simmkyu): Use ng-animate in the future version of AngularJS.
                var emailElement = $('.email-list').children('li').eq(index);
                emailElement.slideUp(400, function() {
                    $scope.adminState.temporaryEmailList.splice(index, 1);
                });
            };

            $scope.removeTemporaryInvalidEmail = function(index) {
                $scope.adminState.temporaryInvalidEmailList.splice(index, 1);
                checkAddEmailErrorMessage();
            };

            $scope.getReadableSharingScope = function(sharingScope) {
                switch (sharingScope) {
                    case $scope.SHARE_SETTINGS_SCOPE_NONE:
                        return $translate.instant('MESSAGES.SHARE_SETTINGS_SCOPE_INTERNAL_NONE');
                    case $scope.ORGANIZATION_SCOPE_ANYONE:
                        return $translate.instant('MESSAGES.SHARE_SETTINGS_SCOPE_ANYONE');
                    case $scope.ORGANIZATION_SCOPE_DOMAINS:
                        return $translate.instant('MESSAGES.SHARE_SETTINGS_SCOPE_DOMAINS');
                    case $scope.ORGANIZATION_SCOPE_ORGANIZATION:
                        return $translate.instant('MESSAGES.SHARE_SETTINGS_SCOPE_ORGANIZATION');
                }
            };
            $scope.getReadableAnonymousSharingScope = function(sharingScope) {
                switch (sharingScope) {
                    case $scope.SHARE_SETTINGS_SCOPE_NONE:
                        return $translate.instant('MESSAGES.SHARE_SETTINGS_SCOPE_NONE');
                    case $scope.ORGANIZATION_SCOPE_ANYONE:
                        return $translate.instant('MESSAGES.SHARE_SETTINGS_SCOPE_ANYONE_ANONYMOUS');
                    case $scope.ORGANIZATION_SCOPE_ORGANIZATION:
                        return $translate.instant('MESSAGES.SHARE_SETTINGS_SCOPE_ORGANIZATION_ANONYMOUS');
                    case $scope.ORGANIZATION_SCOPE_POWERUSER:
                    	return $translate.instant('MESSAGES.SHARE_SETTINGS_SCOPE_POWERUSER_ANONYMOUS');
                }
            };

            $scope.getReadableInviteScope = function(sharingScope) {
                switch (sharingScope) {
                    case $scope.ORGANIZATION_SCOPE_ANYONE:
                        if ($scope.adminState.organizationType !== $scope.ORGANIZATION_TYPE_STANDALONE) {
                            return $translate.instant('MESSAGES.INVITE_SETTINGS_CONNECTED_ORG_SCOPE_ANY_ONE');
                        } else {
                            return $translate.instant('MESSAGES.INVITE_SETTINGS_STAND_ALONE_ORG_SCOPE_ANY_ONE');
                        }
                        break;
                    case $scope.ORGANIZATION_SCOPE_DOMAINS:
                        if ($scope.adminState.organizationType !== $scope.ORGANIZATION_TYPE_STANDALONE) {
                            return $translate.instant('MESSAGES.INVITE_SETTINGS_CONNECTED_ORG_SCOPE_DOMAINS');
                        } else {
                            return $translate.instant('MESSAGES.INVITE_SETTINGS_SCOPE_DOMAINS');
                        }
                        break;
                    case $scope.ORGANIZATION_SCOPE_POWERUSER:
                        if ($scope.adminState.organizationType !== $scope.ORGANIZATION_TYPE_STANDALONE) {
                            return $translate.instant('MESSAGES.INVITE_SETTINGS_CONNECTED_ORG_SCOPE_POWERUSER');
                        } else {
                            return $translate.instant('MESSAGES.INVITE_SETTINGS_SCOPE_POWERUSER');
                        }
                        break;
                    case $scope.ORGANIZATION_SCOPE_ADMIN:
                        if ($scope.adminState.organizationType !== $scope.ORGANIZATION_TYPE_STANDALONE) {
                            return $translate.instant('MESSAGES.INVITE_SETTINGS_CONNECTED_ORG_SCOPE_ADMIN');
                        } else {
                            return $translate.instant('MESSAGES.INVITE_SETTINGS_STAND_ALONE_ORG_SCOPE_ADMIN');
                        }
                        break;
                }
            };

            $scope.updateOrganizationLocale = function() {
                OrganizationService.setOrganizationLocale($scope.languageSettings.locale)
                .success(function() {
                    $rootScope.siteLanguageLocale = $scope.languageSettings.locale;
                    MessageManager.addSuccessMessage($translate.instant('MESSAGES.EMAIL_LANGUAGE_NOTIFICATION_UPDATE_SUCCESS'));
                })
                .error(function(error) {
                    $log.error(error.message);
                });
            };

            $scope.updateSharingRule = function () {
                var newSharingRule = {};
                var newInviteUserRule = {};
                var newNewUserRule = null;
                var selfActivationRule = null;
                var newOrgWideSharingScope = null;
                newSharingRule.Scope = this.adminState.temporaryScope;
                newInviteUserRule.Scope = this.adminState.temporaryInviteScope;

                if( $scope.isPowerUserEnabled ){
                	if (newInviteUserRule.Scope == 'DOMAINS') {
                        if (!this.adminState.temporaryDomainList || this.adminState.temporaryDomainList.length === 0) {
                            MessageManager.addErrorMessage($translate.instant('MESSAGES.SECURITY_ORGANIZATION_UPDATE_FAIL_DOMAIN_DEFAULT'));
                            return;
                        } else {
                        	newInviteUserRule.Domains = this.adminState.temporaryDomainList;
                        	var invalidInviteDomainText = $filter('filter')(newInviteUserRule.Domains, $scope.filterInvalidDomain);
                            if (invalidInviteDomainText && invalidInviteDomainText.length) {
                                MessageManager.addErrorMessage($translate.instant('MESSAGES.SECURITY_ORGANIZATION_UPDATE_FAIL_INVALID_DOMAIN'));
                                return;
                            }
                        }
                    } else {
                        $scope.adminState.temporaryDomainList = null;
                    }
                    if ((this.adminState.temporaryIsNewADUserTypeManaged != this.adminState.isNewADUserTypeManaged) ||
                            (this.adminState.temporaryIsNewExternalUserTypeManaged != this.adminState.isNewExternalUserTypeManaged)) {
                        newNewUserRule = {};
                        // If there was any change made by Admin, only then update this setting.
                        // Make sure to set both NewEnterpriseUserType and NewExternalUserType even if one was changed, to prevent overwriting on server.
                        if (this.adminState.temporaryIsNewADUserTypeManaged) {
                            newNewUserRule.NewEnterpriseUserType = $scope.NEW_USER_TYPE_MANAGED;
                        } else {
                            newNewUserRule.NewEnterpriseUserType = $scope.NEW_USER_TYPE_MINIMAL;
                        }
                        if ($scope.adminState.temporaryExternalShareAllowStatus) {
                            // It is meaningful to update NewExternalUserType only when ExternalShare is applicable and allowed for this site.
                            if (this.adminState.temporaryIsNewExternalUserTypeManaged) {
                                newNewUserRule.NewExternalUserType = $scope.NEW_USER_TYPE_MANAGED;
                            } else {
                                newNewUserRule.NewExternalUserType = $scope.NEW_USER_TYPE_MINIMAL;
                            }
                        }
                    }
                    if (this.adminState.temporaryIsSelfActivationEnabled !== this.adminState.isSelfActivationEnabled) {
                        if (this.adminState.temporaryIsSelfActivationEnabled) {
                            selfActivationRule = {AllowStatus: $scope.ALLOWSTATUS_ENABLED};
                        } else {
                            selfActivationRule = {AllowStatus: $scope.ALLOWSTATUS_DISABLED};
                        }
                    }
                    if(this.adminState.temporaryScope === 'NONE'){
                        newSharingRule = {Scope: 'ORGANIZATION'};
                        newOrgWideSharingScope = this.adminState.temporaryScope;
                    } else {
                        newOrgWideSharingScope = 'MANAGED';
                    }
                	OrganizationService.setOrganizationRules(newSharingRule,newInviteUserRule,newNewUserRule, selfActivationRule, newOrgWideSharingScope)
                	.success(function(data) {
                        $scope.adminState.sharingScope = $scope.adminState.temporaryScope;
                        $scope.adminState.inviteScope = $scope.adminState.temporaryInviteScope;
                        $scope.adminState.inviteDomainList = $scope.adminState.temporaryDomainList;
                        $scope.adminState.isNewADUserTypeManaged = (data.Organization && data.Organization.NewUserRule && data.Organization.NewUserRule.NewEnterpriseUserType===$scope.NEW_USER_TYPE_MANAGED)?true:false;
                        $scope.adminState.isNewExternalUserTypeManaged = (data.Organization && data.Organization.NewUserRule && data.Organization.NewUserRule.NewExternalUserType===$scope.NEW_USER_TYPE_MANAGED)?true:false;
                        $scope.adminState.isSelfActivationEnabled = $scope.adminState.temporaryIsSelfActivationEnabled;
                        MessageManager.addSuccessMessage($translate.instant('MESSAGES.SECURITY_UPDATE_SUCCESS'));
                    })
                    .error(function(data, status, headers, config) {
                        if (data.Message && data.Message.indexOf('EntityNotExistsException') >= 0) {
                            MessageManager.addErrorMessage($translate.instant('MESSAGES.SECURITY_UPDATE_FAIL_NOT_EXISTS'));
                        } else if (data.Message && data.Message.indexOf('InvalidDomainNameException') >= 0) {
                            MessageManager.addErrorMessage($translate.instant('MESSAGES.SECURITY_ORGANIZATION_UPDATE_FAIL_INVALID_DOMAIN'));
                        } else {
                            MessageManager.addErrorMessage($translate.instant('MESSAGES.SECURITY_UPDATE_FAIL_DEFAULT'));
                        }
                    });
                }
                else{
                	if (newSharingRule.Scope === 'DOMAINS') {
                        if (!this.adminState.temporaryDomainList || this.adminState.temporaryDomainList.length === 0) {
                            MessageManager.addErrorMessage($translate.instant('MESSAGES.SECURITY_ORGANIZATION_UPDATE_FAIL_DOMAIN_DEFAULT'));
                            return;
                        } else {
                            newSharingRule.Domains = this.adminState.temporaryDomainList;
                            var invalidDomainText = $filter('filter')(newSharingRule.Domains, $scope.filterInvalidDomain);
                            if (invalidDomainText && invalidDomainText.length) {
                                MessageManager.addErrorMessage($translate.instant('MESSAGES.SECURITY_ORGANIZATION_UPDATE_FAIL_INVALID_DOMAIN'));
                                return;
                            }
                        }
                    } else {
                        $scope.adminState.temporaryDomainList = null;
                    }

                    if(this.adminState.temporaryScope === 'NONE'){
                        newSharingRule = {Scope: 'ORGANIZATION'};
                        newOrgWideSharingScope = this.adminState.temporaryScope;
                    } else {
                        newOrgWideSharingScope = 'MANAGED';
                    }

                    OrganizationService.setOrganizationRules(newSharingRule, null, null, null, newOrgWideSharingScope)
                    .success(function(data) {
                        $scope.adminState.sharingScope = $scope.adminState.temporaryScope;
                        $scope.adminState.sharingDomainList = $scope.adminState.temporaryDomainList;
                        MessageManager.addSuccessMessage($translate.instant('MESSAGES.SECURITY_UPDATE_SUCCESS'));
                    })
                    .error(function(data, status, headers, config) {
                        if (data.Message && data.Message.indexOf('EntityNotExistsException') >= 0) {
                            MessageManager.addErrorMessage($translate.instant('MESSAGES.SECURITY_UPDATE_FAIL_NOT_EXISTS'));
                        } else if (data.Message && data.Message.indexOf('InvalidDomainNameException') >= 0) {
                            MessageManager.addErrorMessage($translate.instant('MESSAGES.SECURITY_ORGANIZATION_UPDATE_FAIL_INVALID_DOMAIN'));
                        } else {
                            MessageManager.addErrorMessage($translate.instant('MESSAGES.SECURITY_UPDATE_FAIL_DEFAULT'));
                        }
                    });
                }
                sharingModal.close();
                if($scope.isExternalSharingEnabled) {
                    if($scope.adminState.organizationType === $scope.ORGANIZATION_TYPE_CONNECTED && $scope.adminState.temporaryExternalShareAllowStatus) {
                        OrganizationService.convertOrganization($scope.adminState.organizationId)
                        .success(function() {
                            callUpdateOrganizationForExternalShare();
                        })
                        .error(function() {
                            MessageManager.addErrorMessage($translate.instant('MESSAGES.SECURITY_UPDATE_FAIL_CONNOT_UPDATE_EXTERNAL_USER_INVITE_SETTING'));
                        });
                    } else if($scope.adminState.organizationType === $scope.ORGANIZATION_TYPE_FEDERATED){
                        callUpdateOrganizationForExternalShare();
                    }
                }
            };

            $scope.updateInviteRule = function () {
                var newInviteRule = {};

                newInviteRule.Scope = this.adminState.temporaryScope;

                if (newInviteRule.Scope == 'DOMAINS') {
                    if (!this.adminState.temporaryDomainList || this.adminState.temporaryDomainList.length === 0) {
                        MessageManager.addErrorMessage($translate.instant('MESSAGES.SECURITY_ORGANIZATION_UPDATE_FAIL_DOMAIN_DEFAULT'));
                        return;
                    } else {
                        newInviteRule.Domains = this.adminState.temporaryDomainList;
                        var invalidDomainText = $filter('filter')(newInviteRule.Domains, $scope.filterInvalidDomain);
                        if (invalidDomainText && invalidDomainText.length) {
                            MessageManager.addErrorMessage($translate.instant('MESSAGES.SECURITY_ORGANIZATION_UPDATE_FAIL_INVALID_DOMAIN'));
                            return;
                        }
                    }
                } else {
                    $scope.adminState.temporaryDomainList = null;
                }

                adminInviteModal.close();

                OrganizationService.setOrganizationRules(null, newInviteRule, null, null, null)
                .success(function(data) {
                    $scope.adminState.inviteScope = $scope.adminState.temporaryScope;
                    $scope.adminState.inviteDomainList = $scope.adminState.temporaryDomainList;
                    MessageManager.addSuccessMessage($translate.instant('MESSAGES.SECURITY_UPDATE_SUCCESS'));
                })
                .error(function(data, status, headers, config) {
                    if (data.Message && data.Message.indexOf('EntityNotExistsException') >= 0) {
                        MessageManager.addErrorMessage($translate.instant('MESSAGES.SECURITY_UPDATE_FAIL_NOT_EXISTS'));
                    } else if (data.Message && data.Message.indexOf('InvalidDomainNameException') >= 0) {
                        MessageManager.addErrorMessage($translate.instant('MESSAGES.SECURITY_ORGANIZATION_UPDATE_FAIL_INVALID_DOMAIN'));
                    } else {
                        MessageManager.addErrorMessage($translate.instant('MESSAGES.SECURITY_UPDATE_FAIL_DEFAULT'));
                    }
                });
            };

            $scope.updateIndividualLimit = function() {
                individualLimitModal.close();

                OrganizationService.setOrganizationStorageLimit($scope.adminState.individualDefaultLimit * BYTES_TO_GIGABYTES, $scope.adminState.temporary.individualUnlimited)
                .success(function(data) {
                    data = angular.fromJson(data);
                    setFromOrganization(data.Organization);
                    MessageManager.addSuccessMessage($translate.instant('MESSAGES.STORAGE_LIMIT_UPDATE_SUCCESS'));
                })

                .error(function() {
                    MessageManager.addErrorMessage($translate.instant('MESSAGES.STORAGE_LIMIT_UPDATE_FAIL_DEFAULT'));
                });
            };

            $scope.updateRecoveryBinRetention = function() {
                var temporaryRecoveryRetentionDaysRound = Math.round($scope.adminState.temporaryRecoveryRetentionDays);
                if (!temporaryRecoveryRetentionDaysRound && temporaryRecoveryRetentionDaysRound !== 0 || temporaryRecoveryRetentionDaysRound > $scope.MAX_RETENTION_DAYS ||
                    temporaryRecoveryRetentionDaysRound < $scope.MIN_RETENTION_DAYS) {

                   MessageManager.addErrorMessage($translate.instant('MESSAGES.RECOVERY_RETENTION_UPDATE_INVALID_RANGE'));
                   return;
                }
                recoveryRetentionModal.close();

                OrganizationService.setContentRetentionTimeInSeconds(temporaryRecoveryRetentionDaysRound * SECONDS_IN_DAY)
                .success(function(data) {
                   data = angular.fromJson(data);
                   setFromOrganization(data.Organization);
                   MessageManager.addSuccessMessage($translate.instant('MESSAGES.RECOVERY_RETENTION_UPDATE_SUCCESS'));
                })
                .error(function() {
                   MessageManager.addErrorMessage($translate.instant('MESSAGES.RECOVERY_RETENTION_UPDATE_FAIL_DEFAULT'));
                });
            };

            $scope.isDisableTextValid = function(contentSearchDisableText) {
                var disableCSPattern = new RegExp($scope.disableContentSearchPattern);
                return disableCSPattern.test(contentSearchDisableText);
            };

            $scope.updateContentSearchFlag = function() {

                if (!$scope.isDisableTextValid($scope.adminState.contentSearchDisableText)) {
                    return;
                }


                // User can only disable the feature, not enable it again,
                OrganizationService.toggleOrgFeature(AppConstants.ORG_FEATURES.INDEX_CONTENT_FOR_SEARCH, false).then(function() {
                    MessageManager.addSuccessMessage($translate.instant('ADMIN.CONTENT_SEARCH_MODAL.SUCCESS.SAVED_CONFIG'));
                    $rootScope.isContentSearchEnabled = false;
                    ClientMetricsService.addEventToSession('DISABLING_CONTENT_SEARCH');
                }, function() {
                    MessageManager.addErrorMessage($translate.instant('ADMIN.CONTENT_SEARCH_MODAL.ERROR.SAVED_CONFIG'));
                }).finally(function() {
                    contentSearchModal.close();
                    contentSearchModal = null;
                });
            };

            $scope.updateUser = function(user) {
                editUserModal.close();

                var postData = {
                    UserId: user.Id
                };

                // Don't muck with the user groups if the user is inactive
                if(($scope.edited_user.Status == UserStatus.USER_STATUS_ACTIVE) ||
                        ($scope.edited_user.Status == UserStatus.USER_STATUS_PENDING) ) {
                    postData.UserTypes = [];

                    if ($scope.isWSUser()) {
                        postData.UserTypes.push(USER_TYPE_WORKSPACESUSER);
                    }

                    // Two cases where the user is part of the user group:
                    // 1. User is an WS user that has been upgraded
                    // 2. User is not a WS user and is also not a minimal user
                    if ($scope.isWSUser()) {
                        if ($scope.isZocaloUser()) {
                            postData.UserTypes.push(USER_TYPE_USER);
                        }
                    }
                    else if(!$scope.edited_user.MinimalUser) {
                        postData.UserTypes.push(USER_TYPE_USER);
                    }

                    if ($scope.edited_user.Administrator) {
                        postData.UserTypes.push(USER_TYPE_ADMIN);
                    }

                    if ($scope.edited_user.Poweruser) {
                        postData.UserTypes.push(USER_TYPE_POWERUSER);
                    }

                    if ($scope.edited_user.MinimalUser) {
                        postData.UserTypes.push(USER_TYPE_MINIMALUSER);
                    }
                }

                if (user.Username != $scope.edited_user.Username) {
                    postData.Username = $scope.edited_user.Username;
                }

                if (user.GivenName != $scope.edited_user.GivenName) {
                    postData.GivenName = $scope.escapeHTML($scope.edited_user.GivenName);
                }

                if (user.Surname != $scope.edited_user.Surname) {
                    postData.Surname = $scope.escapeHTML($scope.edited_user.Surname);
                }

                if (user.Status != $scope.edited_user.Status) {
                    if ($scope.edited_user.Status == UserStatus.USER_STATUS_ACTIVE) {
                        postData.Activate = true;
                    } else {
                        postData.Deactivate = true;
                    }
                }

                // Upgrading a WS User to Zocalo User is activating it
                if ($scope.edited_user.upgradeRequired) {
                    postData.Activate = true;
                }

                if (user.Administrator != $scope.edited_user.Administrator) {
                    if ($scope.edited_user.Administrator) {
                        postData.GrantAdministrativePrivileges = true;
                    } else if (!$scope.edited_user.Administrator) {
                        postData.RevokeAdministrativePrivileges = true;
                    }
                }

                if (user.Poweruser != $scope.edited_user.Poweruser) {
                    if ($scope.edited_user.Poweruser) {
                        postData.GrantPoweruserPrivileges = 'TRUE';
                    } else if (!$scope.edited_user.Administrator) {
                        postData.GrantPoweruserPrivileges = 'FALSE';
                    }
                }

                // When downgrading a ZocaloUser to a Workspace User, Don't set the storage limit
                if (!$scope.edited_user.downgradeRequired) {
                    if ((user.Storage.StorageRule.StorageType != $scope.edited_user.EditedStorage.StorageUnlimited) ||
                        (user.Storage.StorageRule.StorageAllocatedInBytes != $scope.edited_user.EditedStorage.StorageLimit * AppConstants.BYTES_TO_GIGABYTES)) {
                        var newQuota = $scope.edited_user.EditedStorage.StorageLimit * AppConstants.BYTES_TO_GIGABYTES;
                        postData.StorageRule = {
                            StorageAllocatedInBytes: UserService.isValidStorage(newQuota) ? newQuota : 'MALFORMED',
                            StorageType: $scope.edited_user.EditedStorage.StorageUnlimited
                        };
                    }
                }

                UserService.updateUser(user.Id, postData)
                .success(function(data) {
                    if (isUserMyself(data.User)) {
                        AuthService.updateUserInfo(data.User);
                    }

                    var searchedUserId = '';

                    if ($scope.edited_user.inputOwnershipTransfer) {
                        if (!$scope.edited_user.transfereeUser) {
                            MessageManager.addErrorMessage($translate.instant('MESSAGES.TRANSFER_EMAIL_ERROR'));
                            return;
                        }
                        searchedUserId = $scope.edited_user.transfereeUser.Id;
                        UserService.transferUserResources(user.Id, searchedUserId, ($scope.edited_user.GivenName + ' ' + $scope.edited_user.Surname + '\'s files'))
                            .success(function(data) {

                                MessageManager.addSuccessMessage($translate.instant('MESSAGES.USER_UPDATE_SUCCESS', {
                                    name: $scope.escapeHTML(user.Username)
                                }));
                                getOrganizationUsers();
                            })
                            .error(function(data, status, headers, config) {
                                MessageManager.addErrorMessage($translate.instant('MESSAGES.TRANSFER_USER_RESOURCES_FAIL_DEFAULT', {
                                    name: $scope.escapeHTML(user.Username)
                                }));
                            });
                        } else {
                            MessageManager.addSuccessMessage($translate.instant('MESSAGES.USER_UPDATE_SUCCESS', {
                                name: $scope.escapeHTML(user.Username)
                            }));
                            getOrganizationUsers();
                        }
                    })
                .error(function (data, status, headers, config) {
                        if (data.Message && data.Message.indexOf('IllegalUserStateException') >= 0) {
                            MessageManager.addErrorMessage($translate.instant('MESSAGES.USER_UPDATE_FAIL_CAUSE_OF_ILLEGAL_STATE'));
                        } else if (data.Message && data.Message.indexOf('DeactivatingLastSystemUserException') >= 0) {
                            MessageManager.addErrorMessage($translate.instant('MESSAGES.USER_DELETE_FAIL_CAUSE_OF_LAST_USER'));
                        }
                        else {
                            MessageManager.addErrorMessage($translate.instant('MESSAGES.USER_UPDATE_FAIL_DEFAULT', {
                                name: $scope.escapeHTML(user.Username)
                            }));
                        }
                    });
            };

            $scope.reinviteUser = function(user) {
                var emails = [user.Username];


                reinviteUserModal.close();

                InviteService.inviteUsers(emails, '', '', true)
                .success(function(data) {
                    if (data.ResentInvites && data.ResentInvites.length > 0) {
                        MessageManager.addSuccessMessage($translate.instant('MESSAGES.INVITE_SUCCESS_RESENT', {
                            invite: data.ResentInvites.length
                        }, 'messageformat'));
                    }

                    if (data.FailedInvites && data.FailedInvites.length > 0) {
                        MessageManager.addErrorMessage($translate.instant('MESSAGES.INVITE_FAIL_DEFAULT', {
                            n: data.FailedInvites.length
                        }, 'messageformat'));
                    }
                })
                .error(function () {
                    MessageManager.addErrorMessage($translate.instant('MESSAGES.INVITE_FAIL_INVALID_EMAIL'));
                });
            };

            $scope.resendInvites = function() {
                reinvitePendingUsersModal.close();

                InviteService.inviteUsers($scope.pendingInvites, $scope.adminState.temporarySubject, $scope.adminState.temporaryMessage, true)
                    .success(processInviteResponse)
                    .error(processInviteFailure);
            };

            $scope.exportUsers = CompanionService.exportUsers;

            $scope.getUserExportDisabledReason = function() {
                var msg = null;
                if (BrowserService.isMobileOrTablet()) {
                    msg = $translate.instant('MESSAGES.FRICTIONLESS_EDIT.TOOLTIPS.DEVICE_NOT_SUPPORTED');
                } else if (!CompanionService.isCompanionConnectionPossible()) {
                    msg = $translate.instant('MESSAGES.FRICTIONLESS_EDIT.TOOLTIPS.BROWSER_NOT_SUPPORT');
                } else if (!$rootScope.companionDownloadButtonClicked && Utils.compareVersion(EXPORT_USERS_MIN_COMPANION_VERSION, CompanionClientService.getClient().getCompanionVersion()) > 0) {
                    msg = $translate.instant('MESSAGES.FRICTIONLESS_EDIT.TOOLTIPS.OLD_COMPANION', {
                        companionDownloadUrl: CompanionService.getCompanionDownloadUrl()
                    });
                }

                // if there is no reason, return null
                return msg;
            };

            $scope.markCompanionAsInstalled = function() {
                $rootScope.companionDownloadButtonClicked = true;
            };

            $scope.deleteUser = function(user) {
                deleteUserModal.close();

                UserService.deleteUser(user.Id)
                .success(function(data) {
                    MessageManager.addSuccessMessage($translate.instant('MESSAGES.USER_DELETE_SUCCESS', {
                        name: $scope.escapeHTML(user.Username)
                    }));
                    getOrganizationUsers();
                })
                .error(function () {
                    MessageManager.addErrorMessage($translate.instant('MESSAGES.USER_DELETE_FAILED', {
                        name: $scope.escapeHTML(user.Username)
                    }));
                });
            };

            $scope.setStorageType = function(storageType) {
                $scope.edited_user.EditedStorage.StorageUnlimited = storageType;
            };

            $scope.confirmStatusChange = function() {
                if ($scope.edited_user.Active == UserStatus.USER_STATUS_INACTIVE) {
                    var r = window.confirm($translate.instant('MESSAGES.USER_UPDATE_CONFIRM_DEACTIVATE'));
                    if (!r) {
                        $scope.edited_user.Active = true;
                    }
                }
            };

            $scope.changeRole = function(selectedUserRole) {
                if (selectedUserRole === ADMIN_USER && !$scope.edited_user.Administrator) {
                    $scope.edited_user.Administrator = !$scope.edited_user.Administrator;
                    $scope.edited_user.Poweruser = false;
                    $scope.edited_user.managedUser = false;
                    $scope.edited_user.MinimalUser = false;
                }
                if (selectedUserRole === POWER_USER && !$scope.edited_user.Poweruser){
                    $scope.edited_user.Poweruser = !$scope.edited_user.Poweruser;
                    $scope.edited_user.Administrator = false;
                    $scope.edited_user.managedUser = false;
                    $scope.edited_user.MinimalUser = false;
                }
                if ((selectedUserRole === WS_USER || selectedUserRole === GB_USER) && !$scope.edited_user.managedUser){
                    $scope.edited_user.managedUser = !$scope.edited_user.managedUser;
                    $scope.edited_user.Administrator = false;
                    $scope.edited_user.Poweruser = false;
                    $scope.edited_user.MinimalUser = false;
                }
                if (selectedUserRole === MINIMAL_USER && !$scope.edited_user.MinimalUser) {
                    $scope.edited_user.MinimalUser = !$scope.edited_user.MinimalUser;
                    $scope.edited_user.Administrator = false;
                    $scope.edited_user.Poweruser = false;
                    $scope.edited_user.managedUser = false;
                }
            };

            $scope.confirmOwnershipTransfer = function() {
                if ($scope.edited_user.inputOwnershipTransfer) {
                    var r = window.confirm($translate.instant('MESSAGES.CONFIRM_OWNERSHIP_TRANSFER'));
                    if (!r) {
                        $scope.edited_user.inputOwnershipTransfer = false;
                    } else {
                        $scope.edited_user.inputOwnershipTransfer = true;
                    }
                }
            };

            $scope.setTransfereeEmail = function(username) {
                $scope.edited_user.transfereeUsername = username;
            };

            $scope.searchUsers = function() {
                $location.search(generatePath($scope.sortOptionType));
            };

            $scope.clearSearchUsers = function() {
                $scope.query.searchQuery = '';
                $location.search({});
            };

            $scope.sortUsers = function(sortBy) {
                $location.search(generatePath(sortBy));
            };

            // SECTION: Storage functions
            $scope.getReadableStatus = function(user) {
                switch (user.Status) {
                    case UserStatus.USER_STATUS_ACTIVE:
                        return $translate.instant('ADMIN.CONTENT_PARTIAL.ACTIVE');
                    case UserStatus.USER_STATUS_INACTIVE:
                        return $translate.instant('ADMIN.CONTENT_PARTIAL.INACTIVE');
                    default:
                        return $translate.instant('ADMIN.CONTENT_PARTIAL.PENDING');
                }
            };

            // Returns true if the user is a Workspaces user.
            // A User can be both WS user and Zocalo user (using both AWS applications
            // on the same directory).
            $scope.isWSUser = function() {
                return $scope.isWSUserHelper($scope.edited_user.groupTypes);
            };

            $scope.isWSUserHelper = function(groupTypes) {
                if (!!groupTypes) {
                    for (var i = 0, size = groupTypes.length; i < size; i++) {
                        var group = groupTypes[i];
                        if (group === GROUP_TYPE_WS_USER) {
                            return true;
                        }
                    }
                }
                return false;
            };

            // Returns true if the user is a Zocalo User.
            // A User can be both WS user and Zocalo user (using both AWS applications
            // on the same directory).
            $scope.isZocaloUser = function() {
                if (!!$scope.edited_user.groupTypes) {
                    for (var i = 0, size = $scope.edited_user.groupTypes.length; i < size; i++) {
                        var group = $scope.edited_user.groupTypes[i];
                        if (group === GROUP_TYPE_GB_USER) {
                            return true;
                        }
                    }
                }
                return false;
            };

            // Get user role
            $scope.getRole = function(user) {

                // If the user is Administrator
                if (user.Administrator) {
                    return ADMIN_USER;
                }

                if (user.Poweruser) {
                    return POWER_USER;
                }

                if ($scope.isWSUserHelper(user.GroupTypes)) {
                    return WS_USER;
                }

                if (user.MinimalUser){
                    return MINIMAL_USER;
                }

                if (!!user.GroupTypes && user.GroupTypes.length > 0) {
                    return GB_USER;
                }

                // If the user does not belong to any groups and minimal users is enabled for the org, choose minimal user by default
                if($scope.isMinimalUserEnabled) {
                    return MINIMAL_USER;
                }

                return GB_USER;
            };

            $scope.getIndividualStorageLimit = function() {
                if ($scope.adminState.individualUnlimited === StorageType.STORAGE_UNLIMITED_TYPE) {
                    return $translate.instant('ADMIN.ACTIVITY.UNLIMITED');
                }
                return $translate.instant('ADMIN.CONTENT_PARTIAL.NEW_USER_GET_GB', {
                    limitedStorage: $scope.adminState.individualDefaultLimit
                });
            };

            $scope.nextClicked = function() {
                $scope.pagination.previousMarkers.push($scope.pagination.marker);
                getOrganizationUsersWithMarker($scope.pagination.marker);
            };

            $scope.previousClicked = function() {
                $scope.pagination.marker = $scope.pagination.previousMarkers.pop();            
                getOrganizationUsersWithMarker($scope.pagination.previousMarkers[$scope.pagination.previousMarkers.length - 1]);
            };


            $scope.isAdminWorkDrivesEnabled = function() {
                return FeatureManagerService.isFeatureEnabled(Features.UI.ADMIN_WORKDRIVES_LINK);
            };

            $scope.isMeetingsSyncEnabled = function() {
                return FeatureManagerService.isFeatureEnabled(Features.UI.MEETINGS);
            };


            // Main, Get the organization users.
            getOrganizationUsers();

            OrganizationService.getOrganization()
                .success(function(data) {
                    data = angular.fromJson(data);
                    setFromOrganization(data.Organization);
                });

            if ($scope.isO365FeatureEnabled()) {
                OrganizationService.getFeatureDetails(AppConstants.ORG_FEATURES.O365).then(function(data) {
                    if (angular.equals(data, {})) {
                        return;
                    }
                    $scope.adminForm.enableO365 = $scope.adminState.enableO365 = data.Enabled;
                }, function(response) {
                    if (response.status === 404) {
                        // when get AdminFeatureNotFoundException, assume the feature is not enabled
                        // Currently, only AdminFeatureNotFoundException return 404.  https://code.amazon.com/packages/AWSGorillaBoyServiceModel/blobs/5a22a29af2eb6d1954080b47eefb248a69880328/--/model/service-internal/admin-feature/admin-feature-interface.xm
                    } else {
                        MessageManager.addErrorMessage($translate.instant('O365.ERRORS.ERROR_FETCHING_FEATURE_DETAILS'));
                    }
                });
            }

            if ($scope.isMeetingsEnabled) {
                OrganizationService.getFeatureDetails(AppConstants.ORG_FEATURES.MEETINGS).then(function(data) {
                    if (angular.equals(data, {})) {
                        return;
                    }
                    $scope.adminForm.enableMeetings = $scope.adminState.enableMeetings = data.Enabled;
                }, function(response) {
                    if (response.status === 404) {
                        // when get AdminFeatureNotFoundException, assume the feature is not enabled
                        // Currently, only AdminFeatureNotFoundException return 404.  https://code.amazon.com/packages/AWSGorillaBoyServiceModel/blobs/5a22a29af2eb6d1954080b47eefb248a69880328/--/model/service-internal/admin-feature/admin-feature-interface.xm
                    } else {
                        MessageManager.addErrorMessage($translate.instant('MEETINGS.ERRORS.ERROR_FETCHING_FEATURE_DETAILS'));
                    }
                });
            }

            if (FeatureManagerService.isFeatureEnabled(Features.DocumentViewer.ONLINEEDITING)) {
                OrganizationService.getFeatureDetails(AppConstants.ORG_FEATURES.ONLINE_EDITING).then(function(data) {
                    if (angular.equals(data, {})) {
                        return;
                    }
                    $rootScope.onlineEditingEnabled = $scope.onlineEditingForm.enableOnlineEditing = $scope.adminState.enableOnlineEditing = $scope.onlineEditingForm.enableOnlineEditingTemporary = data.Enabled;
                    $scope.adminState.showOnlineEditingSection = true;
                }, function(response) {
                    $rootScope.onlineEditingEnabled = $scope.onlineEditingForm.enableOnlineEditing = $scope.adminState.enableOnlineEditing = $scope.onlineEditingForm.enableOnlineEditingTemporary = false;
                    $scope.adminState.showOnlineEditingSection = true;
                });
            }
            document.title = $translate.instant('ADMIN.TITLE.ADMINISTRATION_DASHBOARD') + ' - ' + AppConstants.APP_NAME;

            if ($scope.isAuditEmailEnabled) {
                $scope.showAuditEmailModal = function() {
                    auditEmailModal = $uibModal.open({
                        templateUrl: 'auditEmailModal.html',
                        scope: $scope
                    });
                    auditEmailModal.result.catch(function() {
                        // called when modal is dismissed.
                        $scope.auditEmailState.newAuditEmail = "";
                    });
                };
    
                $scope.showRemoveAuditEmailModal = function(email) {
                    auditEmailModal.close();
                    $scope.auditEmailState.toRemoveAuditEmail = email;
                    removeAuditEmailModal = $uibModal.open({
                        templateUrl: 'removeAuditEmailModal.html',
                        scope: $scope
                    });
                    removeAuditEmailModal.closed.then(function() {
                        $scope.auditEmailState.toRemoveAuditEmail = '';
                    });
                };
    
                $scope.showConfirmAuditEmailModal = function() {
                    confirmAuditEmailModal = $uibModal.open({
                        templateUrl: 'confirmAuditEmailModal.html',
                        scope: $scope
                    });
                    confirmAuditEmailModal.closed.then(function() {
                        $scope.auditEmailState.newAuditEmail = '';
                    });
                };
    
                $scope.getVerifiedEmailAddress = function() {
                    var emailAddress = $scope.auditEmailState.verifiedEmail;
                    if (!$scope.auditEmailState.verifiedEmail) {
                        emailAddress = $translate.instant('ADMIN.AUDIT_EMAIL_MODAL.NOT_SET');
                    }
                    return emailAddress;
                };
    
                $scope.updateAuditEmail = function() {
                    // https://code.amazon.com/packages/AWSGorillaBoyServiceModel/blobs/mainline/--/model/release/common/types.xml#L140
                    if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test($scope.auditEmailState.newAuditEmail)) {
                        MessageManager.addErrorMessage($translate.instant('ADMIN.AUDIT_EMAIL.MESSAGE.ERROR.INVALID_EMAIL_ADDRESS'));
                        return;
                    }
                    AuditEmailService.addUnverifiedEmail($scope.auditEmailState.newAuditEmail).then(function() {
                        auditEmailModal.close();
                        $scope.auditEmailState.unverifiedEmail = $scope.auditEmailState.newAuditEmail;
                        $scope.showConfirmAuditEmailModal();
                    }, function() {
                        MessageManager.addErrorMessage($translate.instant('ADMIN.AUDIT_EMAIL.MESSAGE.ERROR'));
                    }).finally(function() {
                        $scope.auditEmailState.showSpinner = false;
                    });
    
                    $scope.auditEmailState.showSpinner = true;
                };
    
                $scope.removeAuditEmail = function() {
                    var removeVerified = $scope.auditEmailState.toRemoveAuditEmail === $scope.auditEmailState.verifiedEmail;
                    var removeUnverified = $scope.auditEmailState.toRemoveAuditEmail === $scope.auditEmailState.unverifiedEmail;
                    if (!removeVerified && !removeUnverified) {
                        return;
                    }
    
                    AuditEmailService.removeAuditEmail(removeVerified, removeUnverified).then(function() {
                        if (removeVerified) {
                            MessageManager.addSuccessMessage($translate.instant('ADMIN.AUDIT_EMAIL.MESSAGE.SUCCESS.REMOVE_VERIFIED', {'email_address': $scope.auditEmailState.verifiedEmail}));
                            $scope.auditEmailState.verifiedEmail = "";
                        }
                        if (removeUnverified) {
                            MessageManager.addSuccessMessage($translate.instant('ADMIN.AUDIT_EMAIL.MESSAGE.SUCCESS.REMOVE_UNVERIFIED', {'email_address': $scope.auditEmailState.unverifiedEmail}));
                            $scope.auditEmailState.unverifiedEmail = "";
    
                        }
                        removeAuditEmailModal.close();
                    }, function(err) {
                        MessageManager.addErrorMessage($translate.instant('ADMIN.AUDIT_EMAIL.MESSAGE.ERROR'));
                    });
                };
    
                $scope.resendVerificationEmail = function() {
                    $scope.auditEmailState.showSpinner = true;
                    AuditEmailService.resendAuditEmailVerification().then(function () {
                        MessageManager.addSuccessMessage($translate.instant('ADMIN.AUDIT_EMAIL.MESSAGE.SUCCESS.RESEND_VERIFICATION', {'email_address': $scope.auditEmailState.unverifiedEmail}));
                        auditEmailModal.close();
                        $scope.auditEmailState.showSpinner = false;
                    }, function(err) {
                        MessageManager.addErrorMessage($translate.instant('ADMIN.AUDIT_EMAIL.MESSAGE.ERROR'));
                        $scope.auditEmailState.showSpinner = false;
                    });
                };

                AuditEmailService.getAuditEmails().then(function(response) {
                    if (angular.equals(response, {})) {
                        return;
                    }
                    $scope.auditEmailState.verifiedEmail = response.data.OrganizationAuditEmail.VerifiedEmail;
                    $scope.auditEmailState.unverifiedEmail = response.data.OrganizationAuditEmail.UnverifiedEmail;
                });
    
                if ($routeParams && $routeParams.verify_code) {
                    AuditEmailService.verifyAuditEmail($routeParams.verify_code).then(function() {
                        verifyAuditEmailModal = $uibModal.open({
                            templateUrl: 'verifyAuditEmailModal.html',
                            scope: $scope
                        });
                        return AuditEmailService.getAuditEmails();
                    }, function(err) {
                        MessageManager.addErrorMessage($translate.instant('ADMIN.AUDIT_EMAIL.MESSAGE.ERROR.VERIFICATION_FAILED'));
                    }).then(function(response) {
                        if (angular.equals(response, {})) {
                            $scope.auditEmailState.verifiedEmail = '';
                            $scope.auditEmailState.unverifiedEmail = '';
                            return;
                        }
                        $scope.auditEmailState.verifiedEmail = response.data.OrganizationAuditEmail.VerifiedEmail;
                        $scope.auditEmailState.unverifiedEmail = response.data.OrganizationAuditEmail.UnverifiedEmail;
                    });
                }
            }
            
        }

        function emitO365ConfigChangeMetric(){
            if($scope.adminForm.enableO365 === true){
                ClientMetricsService.addEventToSession(MetricEvents.O365.OFFICE_FEATURE_ENABLED.name);
            } else {
                ClientMetricsService.addEventToSession(MetricEvents.O365.OFFICE_FEATURE_DISABLED.name);
            }
        }

        function getOrganizationUsers() {
            getOrganizationUsersWithMarker($scope.pagination.marker);
        }

        function getOrganizationUsersWithMarker(inputMarker) {
            var promise = null,
                 params = {
                    sortBy: $scope.sortOptionType,
                    order: $scope.sortOptionOrder,
                    pageSize: $scope.COUNT_PER_PAGE,
                    marker: inputMarker
                },
                data;

            if ($scope.query.searchQuery) {
                var escapedSearchQuery = $scope.escapeHTML($scope.query.searchQuery);
                $log.info("about send search with query : " + escapedSearchQuery);
                params.query = escapedSearchQuery;
                promise = OrganizationService.searchOrganizationUsers(params);
            } else {
                $log.info("about send get users");
                promise = OrganizationService.getOrganizationUsers(params);
            }

            promise.then(function (response) {
                data = angular.fromJson(response.data);
                $scope.users = data.Users;
                $scope.pagination.marker = data.Marker;
            }, function (err){
                if (err.status === AppConstants.HttpStatuses.ENTITY_TOO_LARGE) {
                    $log.error("Failed with entity too large");
                    $scope.excessUsers = $translate.instant('MESSAGES.EXCESS_USERS');
                } else{
                    $log.error("Failed with error : " + err);
                }
            });
        }

        function setFromOrganization(organization) {
            $scope.adminState.sharingDomainList = organization.SharingRule.Domains;
            $scope.adminState.orgWideSharingScope = organization.OrgWideSharingScope;
            $scope.adminState.sharingScope = organization.OrgWideSharingScope === 'NONE' ? organization.OrgWideSharingScope : organization.SharingRule.Scope;
            $scope.adminState.inviteDomainList = organization.UserInviteRule.Domains;
            $scope.adminState.inviteScope = organization.UserInviteRule.Scope;
            $scope.adminState.externalShareAllowStatus = (organization.ExternalUserInviteRule && organization.ExternalUserInviteRule.AllowStatus===$scope.ALLOWSTATUS_ENABLED)?true:false;
            $scope.adminState.isNewADUserTypeManaged = (organization.NewUserRule && organization.NewUserRule.NewEnterpriseUserType===$scope.NEW_USER_TYPE_MANAGED)?true:false;
            $scope.adminState.isNewExternalUserTypeManaged = (organization.NewUserRule && organization.NewUserRule.NewExternalUserType===$scope.NEW_USER_TYPE_MANAGED)?true:false;
            $scope.adminState.isSelfActivationEnabled = (organization.SelfActivationRule && organization.SelfActivationRule.AllowStatus===$scope.ALLOWSTATUS_ENABLED)?true:false;
            $scope.adminState.externalShareScope = (organization.ExternalUserInviteRule && organization.ExternalUserInviteRule.Scope)?organization.ExternalUserInviteRule.Scope:$scope.ORGANIZATION_SCOPE_MANAGED; // If Scope is not available, defaulting to MANAGED because, the admin could possibly click submit without choosing any option which would throw an error.
            $scope.adminState.organizationalStorageUsed = organization.StorageMetadata.StorageUtilizedInBytes / AppConstants.BYTES_TO_GIGABYTES;
            $scope.adminState.individualDefaultLimit = organization.StorageMetadata.StorageRule.StorageAllocatedInBytes / AppConstants.BYTES_TO_GIGABYTES;
            $scope.adminState.individualUnlimited = organization.StorageMetadata.StorageRule.StorageType;
            $scope.adminState.organizationName = organization.Name;
            $scope.adminState.organizationType = organization.Mode;
            $scope.adminState.organizationId = organization.Id;
            $scope.languageSettings.locale = organization.Locale;
            $scope.adminState.organizationalNumWorkDrives = 123; // Temporary value, change later.
            $scope.adminState.recoveryRetentionDays = Math.round(organization.ContentRetentionTimeInSeconds / SECONDS_IN_DAY);
            AppConstants.ORG_WIDE_SHARING_SCOPE = $scope.adminState.sharingScope;
        }

        function isUserMyself(user) {
            return user && user.Id === userInfo.Id;
        }

        function processInviteFailure(data) {
            if(data && data.Message && data.Message.indexOf('NoRetryThrottlingException') >= 0) {
                MessageManager.addErrorMessage($translate.instant('MESSAGES.INVITE_SEND_FAIL_LIMIT_REACHED'));
            } else {
                MessageManager.addErrorMessage($translate.instant('MESSAGES.INVITE_FAIL_INVALID_EMAIL'));
            }
        }

        function processInviteResponse(data) {
            if (data.NewInvites && data.NewInvites.length > 0) {
                MessageManager.addSuccessMessage($translate.instant('MESSAGES.INVITE_SUCCESS_DEFAULT', {
                    count: data.NewInvites.length
                }, 'messageformat'));
                // Refresh the entries in the Users table
                getOrganizationUsers();
            }

            if (data.ResentInvites && data.ResentInvites.length > 0) {
                MessageManager.addSuccessMessage($translate.instant('MESSAGES.INVITE_SUCCESS_RESENT', {
                    invite: data.ResentInvites.length
                }, 'messageformat'));
            }

            if (data.ExistingUsers && data.ExistingUsers.length > 0) {
                MessageManager.addSuccessMessage($translate.instant('MESSAGES.INVITE_SUCCESS_EXISTING', {
                    n: data.ExistingUsers.length
                }, 'messageformat'));
            }

            if (data.FailedInvites && data.FailedInvites.length > 0) {
                MessageManager.addErrorMessage($translate.instant('MESSAGES.INVITE_FAIL_DEFAULT', {
                    n: data.FailedInvites.length
                }, 'messageformat'));
            }

            if (data.PendingInvites && data.PendingInvites.length > 0 && data.ResentInvites.length === 0) {
                $scope.showReinviteUserModalFromInvite(data.PendingInvites);
            } else {
                $scope.adminState.temporaryEmailList = [];
                $scope.adminState.temporaryEmail = '';
                $scope.adminState.temporarySubject = '';
                $scope.adminState.temporaryMessage = '';
                if (inviteModal) {
                    inviteModal.dismiss();
                }
                if (reinviteUserModal) {
                    reinviteUserModal.dismiss();
                }
                if (reinvitePendingUsersModal) {
                    reinvitePendingUsersModal.dismiss();
                }
            }
        }
        function generatePath(sort_type) {
            var params = {};
            if ($scope.query.searchQuery) {
                params.searchQuery = $scope.escapeHTML($scope.query.searchQuery);
            }

            if (sort_type) {
                if (sort_type == $scope.sortOptionType && !$scope.query.searchQuery) {
                    params.order = SortService.getOppositeOrder($scope.sortOptionOrder);
                } else {
                    params.order = sortOrder.ASCENDING;
                }
                params.sortBy = sort_type;
            }
            return params;
        }
        function callUpdateOrganizationForExternalShare(){
            var newExternalUserInviteRule = {};
            newExternalUserInviteRule.AllowStatus = $scope.adminState.temporaryExternalShareAllowStatus ? $scope.ALLOWSTATUS_ENABLED:$scope.ALLOWSTATUS_DISABLED;
            newExternalUserInviteRule.Scope = $scope.adminState.temporaryExternalShareScope;

            OrganizationService.setOrganizationExternalInviteRule(newExternalUserInviteRule)
            .success(function(data) {
                $scope.adminState.externalShareScope = $scope.adminState.temporaryExternalShareScope;
                $scope.adminState.externalShareAllowStatus = $scope.adminState.temporaryExternalShareAllowStatus;
                MessageManager.addSuccessMessage($translate.instant('MESSAGES.SECURITY_UPDATE_SUCCESS'));
            })
            .error(function(data, status, headers, config) {
                MessageManager.addErrorMessage($translate.instant('MESSAGES.SECURITY_UPDATE_FAIL_CONNOT_UPDATE_EXTERNAL_USER_INVITE_SETTING'));
            });
        }
    }
}());
